import {css, Global} from '@emotion/react';
import normalize from 'emotion-normalize';
import "../font/font.css";

const globalStyles = css`
    ${normalize}
    html {
        font-size: 12px;
        color:#2B2F34;

        @media (min-width: 331px) {
            font-size: 14px;
        }

        @media (min-width: 351px) {
            font-size: 16px;
        }
    }

    * {
        font-family: 'Daki', 'daki', 'SpoqaHanSans', 'Spoqa Han Sans Neo', 'Pretendard', '맑은고딕', 'Malgun Gothic', '돋움', Dotum, 'Apple Gothic', sans-serif;
        box-sizing: border-box;
        color:#2B2F34;

    }

    input {
        &:focus {
            outline: none;
        }
    }
`;

const GlobalStyles = () => <Global styles={globalStyles}/>;

export default GlobalStyles;
